
define('ldsh!modules/form_editor/templates/editor_advanced_password_amp', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (!isPopup) { ;
__p += '\n<div class="editor-form-group ed-form-group ed-advanced-item ' +
((__t = ( confirmation ? '' : 'hidden' )) == null ? '' : __t) +
'">\n  <label\n    class="control-label"\n    for=""\n    data-i18n="[text]formEditor.passwordConfirmationDifferentMessageLabel"></label>\n  <input\n    type="text"\n    class="form-control ed-input-group js-confirmation-different-message"\n    value="' +
((__t = ( confirmationDifferentMessage )) == null ? '' : __t) +
'">\n</div>\n';
 } ;
__p += '\n';

}
return __p
};});

